import {
  defineComponent as c,
  ref as l,
  onMounted as r,
  nextTick as i,
  openBlock as p,
  createElementBlock as u,
  createElementVNode as _,
} from 'vue';
import { Pane as d } from 'tweakpane';
import * as f from '@tweakpane/plugin-essentials';
/*!
 * v-tweakpane v0.2.0
 * (c) 2022 Vinayak Kulkarni
 * @license MIT
 */
const m = c({
  name: 'VTweakpane',
  props: {
    pane: {
      type: Object,
      default: () => {},
      required: !0,
    },
  },
  emits: ['on-pane-created'],
  setup(e, { emit: a }) {
    const n = l(null),
      t = l(null);
    return (
      r(() => {
        i(() => {
          n.value instanceof Element &&
            ((t.value = new d({
              container: n.value,
              title: e.pane.title,
              expanded: e.pane.expanded,
            })),
            t.value.registerPlugin(f),
            a('on-pane-created', t.value));
        });
      }),
      {
        el: n,
      }
    );
  },
});
const v = (e, a) => {
    const n = e.__vccOpts || e;
    for (const [t, o] of a) n[t] = o;
    return n;
  },
  k = { class: 'w-full h-full' },
  x = { ref: 'el' };
function w(e, a, n, t, o, $) {
  return p(), u('main', k, [_('div', x, null, 512)]);
}
const V = /* @__PURE__ */ v(m, [['render', w]]),
  g = (e) => {};
let s = !1;
const T = (e) => {
    s || (g(), e.component('VTweakpane', V), (s = !0));
  },
  E = T;
export { V as VTweakpane, E as default };
//# sourceMappingURL=v-tweakpane.js.map
